import React, { useState } from "react";
import ConcretePhoto1 from "../../images/services/concrete.webp";
import ConcretePhoto2 from "../../images/services/concrete.jpg";
import ConcretePhoto3 from "../../images/services/IMG_2370.jpg";
import { FaMapMarkedAlt, FaClock } from "react-icons/fa";
import "./ServiceDetailStyles.css";

function Concrete() {
  const slides = [ConcretePhoto1, ConcretePhoto2, ConcretePhoto3];
  const [current, setCurrent] = useState(0);

  const nextSlide = () => setCurrent((prev) => (prev + 1) % slides.length);
  const prevSlide = () =>
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);

  return (
    <>
      <div className="ttm-page-title ttm-bg clearfix">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="ttm-page-title-row-inner">
                <div className="page-title-heading">
                  <h2 className="title">Concrete</h2>
                </div>
                <div className="breadcrumb-wrapper">
                  <span>
                    <a title="Services" href="/services">
                      <i className="fa fa-house" /> &nbsp; Services
                    </a>
                  </span>
                  <span>Concrete</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* MAIN */}
      <section className="brw-service-detail brw-service-detail--concrete">
        <div className="container">
          <div className="row brw-service-detail__layout">
            {/* SIDEBAR */}
            <div className="col-lg-4">
              <div className="brw-service-detail__sidebar">
                <h4>Our Services</h4>
                <ul className="brw-service-detail__service-list">
                  <li>
                    <a href="/undergroundUtilities">Underground Utilities</a>
                  </li>
                  <li>
                    <a href="/earthwork">Earthwork</a>
                  </li>
                  <li>
                    <a href="/pavingStriping">Paving & Striping</a>
                  </li>
                  <li>
                    <a href="/roadwayConstruction">Roadway Construction</a>
                  </li>
                  <li>
                    <a href="/segmentedRetainingWalls">
                      Segmented Retaining Walls
                    </a>
                  </li>
                  <li className="active">
                    <a href="/concrete">Concrete</a>
                  </li>
                </ul>

                <div className="brw-service-detail__info-card">
                  <FaMapMarkedAlt />
                  <h5>Service Area</h5>
                  <p>
                    Central Florida & Surrounding Areas
                  </p>
                </div>

                <div className="brw-service-detail__info-card">
                  <FaClock />
                  <h5>Office Hours</h5>
                  <p>
                    Mon–Fri: 8:00 AM – 5:00 PM
                  </p>
                </div>
              </div>
            </div>

            {/* CONTENT */}
            <div className="col-lg-8">
              <div className="brw-service-detail__showcase">
                {/* SLIDER */}
                <div className="brw-service-detail__media">
                  <button
                    className="brw-service-detail__arrow brw-service-detail__arrow--prev"
                    onClick={prevSlide}
                    aria-label="Previous Slide"
                  >
                    ‹
                  </button>
                  <img
                    src={slides[current]}
                    alt="Concrete Slide"
                    className="brw-service-detail__image"
                  />
                  <button
                    className="brw-service-detail__arrow brw-service-detail__arrow--next"
                    onClick={nextSlide}
                    aria-label="Next Slide"
                  >
                    ›
                  </button>
                </div>

                <h4>Top-Notch Concrete Work</h4>
                <p>
                  We provide a comprehensive range of concrete services,
                  including cast-in-place walls, structures, sidewalks, curbs,
                  and more. Our skilled team uses premium materials and advanced
                  techniques to ensure precision and excellence in every
                  project.
                </p>
                <p>
                  Whether it's a small sidewalk installation or a large
                  commercial venture, we apply the same dedication and expertise
                  to deliver lasting durability and visual appeal.
                </p>
                <div className="brw-service-detail__chips">
                  <span>Cast-in-place concrete</span>
                  <span>Sidewalks & curbs</span>
                  <span>Structural concrete</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Concrete;
